import { styled } from '@mui/material/styles';

import SwipeableDrawer from '@mui/material/SwipeableDrawer';

const navbarWidth = 272;
const backgroundColor = '#FFFFFF';

type StyledNavBarProps = {
    open: boolean;
    position: string;
    theme: any;
    className: any;
}


export const StyledNavBar = styled('div')((props: StyledNavBarProps) => {
    const { theme, open, position } = props;
    
    return ({
        borderRight: '1px solid #E8E8E8',
        minWidth: navbarWidth,
        width: navbarWidth,
        maxWidth: navbarWidth,
        ...(!open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.leavingScreen+100,
            }),
            ...(position === 'left' && {
                marginLeft: `-${navbarWidth}px`,
            }),
            ...(position === 'right' && {
                marginRight: `-${navbarWidth}px`,
            }),
        }),
        ...(open && {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }),
    });
});

export const StyledNavBarMobile = styled(SwipeableDrawer)(({ theme }) => ({
    '& .MuiDrawer-paper': {
        minWidth: navbarWidth,
        width: navbarWidth,
        maxWidth: navbarWidth,
    },
}));


export const MenuContainer = styled('div')(({ theme }) => ({
    backgroundColor: backgroundColor,
    color: theme.palette.text.primary,
    '& ::-webkit-scrollbar-thumb': {
        boxShadow: `inset 0 0 0 20px ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.24)' : 'rgba(255, 255, 255, 0.24)'
            }`,
    },
    '& ::-webkit-scrollbar-thumb:active': {
        boxShadow: `inset 0 0 0 20px ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.37)' : 'rgba(255, 255, 255, 0.37)'
            }`,
    },
}));


export const MenuItemContainer = styled('div')(({ theme, className }) => {
    return({
        cursor:'pointer',
        color: theme.palette.text.primary,
        ...(!className.includes('active') && {
            '&:hover': {
                background:'#EFF4FC'
            },
        })
    })
});
